import { Link } from 'react-router';
import { Zap, Users, FileText } from 'lucide-react';
import type { WidgetProps } from '../../../core/types/widget.types';

export function WallboxQuickActionsWidget({ widgetId: _ }: WidgetProps) {
    return (
        <div className="flex flex-wrap gap-3">
            <Link
                to="/wallbox/charges"
                className="px-4 py-3 bg-white border border-gray-100 rounded-xl text-sm font-bold text-charcoal hover:bg-gray-50 transition-all shadow-xs flex items-center gap-3 group"
            >
                <div className="w-8 h-8 rounded-lg bg-primary-50 text-primary flex items-center justify-center group-hover:bg-primary group-hover:text-white transition-colors">
                    <Zap size={16} />
                </div>
                Ladevorgänge
            </Link>
            <Link
                to="/wallbox/users"
                className="px-4 py-3 bg-white border border-gray-100 rounded-xl text-sm font-bold text-charcoal hover:bg-gray-50 transition-all shadow-xs flex items-center gap-3 group"
            >
                <div className="w-8 h-8 rounded-lg bg-charcoal-50 text-charcoal flex items-center justify-center group-hover:bg-charcoal group-hover:text-white transition-colors">
                    <Users size={16} />
                </div>
                Benutzer
            </Link>
            <Link
                to="/wallbox/invoices"
                className="px-4 py-3 bg-white border border-gray-100 rounded-xl text-sm font-bold text-charcoal hover:bg-gray-50 transition-all shadow-xs flex items-center gap-3 group"
            >
                <div className="w-8 h-8 rounded-lg bg-gold-50 text-gold-600 flex items-center justify-center group-hover:bg-gold-600 group-hover:text-white transition-colors">
                    <FileText size={16} />
                </div>
                Rechnungen
            </Link>
        </div>
    );
}
